import { Component, OnInit, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NLSTransaction } from 'src/app/model/NLSTransaction';
import { NLSTransactionService } from 'src/app/services/nls-transaction/nls-transaction.service';

@Component({
    selector: 'app-supplier-upcoming-transactions-table',
    templateUrl: './supplier-upcoming-transactions-table.component.html',
    styleUrl: './supplier-upcoming-transactions-table.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SupplierUpcomingTransactionsTableComponent implements OnInit, OnDestroy {
    /** Dependency injections */
    private _nlsTransactionService = inject(NLSTransactionService);

    /** Upcoming transactions to render (current_balance > 0) */
    upcomingTransactions: NLSTransaction[] = [];

    /** Loading state */
    loading = true;

    /** Table columns */
    displayedColumns: string[] = [
        'transaction_id',
        'buyer_company',
        'buyer_id',
        'last_update_date',
        'amount',
        'statusTitleCase',
        'current_balance',
    ];

    /** Subscription for data */
    private transactionEventsSub?: Subscription;

    /**
     * OnInit, subscribe to data changes and initialize data source
     */
    ngOnInit(): void {
        // Subscribe to transaction events
        this.transactionEventsSub = this._nlsTransactionService.changes$.subscribe((nlsTransactions: NLSTransaction[]) => {
            // Filter for upcoming transactions (current_balance > 0)
            this.upcomingTransactions = nlsTransactions.filter(transaction => transaction.current_balance > 0);
            this.loading = false;
        });

        // Get latest data from nls transaction service
        const nlsTransactions = this._nlsTransactionService.getEntities();
        if (nlsTransactions) {
            this.upcomingTransactions = nlsTransactions.filter((transaction: NLSTransaction) => transaction.current_balance > 0);
            this.loading = false;
        }
    }

    /**
     * On component destroy, unsubscribe from all subscriptions
     */
    ngOnDestroy(): void {
        if (this.transactionEventsSub) {
            this.transactionEventsSub.unsubscribe();
        }
    }

    /**
     * Format currency values
     * 
     * @param amount The amount to format
     * @return The formatted currency string
     */
    formatCurrency(amount: number): string {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(amount);
    }

    /**
     * Format date values
     * 
     * @param date The date to format
     * @return The formatted date string
     */
    formatDate(date: Date | null): string {
        if (!date) return 'N/A';
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).format(new Date(date));
    }
}
